import { ForgotPasswordComponent } from './modules/auth/pages/forgot-password/forgot-password.component';
import { LandingPageComponent } from './modules/sidebar-views/pages/landing-page/landing-page.component';
import { ErrorPageComponent } from './themes/content/error-page/error-page.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThemeBaseComponent } from './themes/base/theme-base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { WelcomePageComponent } from './modules/welcome/pages/welcome-page/welcome-page.component';
import { LoginPageComponent } from './modules/auth/pages/login-page/login-page.component';
import { ResetPasswordComponent } from './modules/auth/pages/reset-password/reset-password.component';
import { ChangePasswordComponent } from './modules/auth/pages/change-password/change-password.component';
import { CampaignGuard } from './core/guard/campaign.guard';
import { WelcomePageContentResolver } from './modules/welcome/resolver/welcome-page-content.resolver';
import { DonorCampaignsListResolver } from './core/resolvers/donor-campaign-list-resolver';
import { CurrentCampaignsResolver } from './core/resolvers/current-campaign.resolver';
import { StandaloneForgotPasswordComponent } from './modules/auth/pages/standalone-forgot-password/standalone-forgot-password.component';
import { StandaloneParentPageComponent } from './modules/standalone-login/pages/standalone-parent-page/standalone-parent-page.component';
import { UserRegistrationFeedbackComponent } from './modules/auth/pages/user-registration-feedback/user-registration-feedback.component';
import { AppSelectionComponent } from './modules/auth/pages/app-selection/app-selection.component';
import { MfaComponent } from './modules/auth/pages/mfa/mfa.component';
import { RegistrationTokenVerificationComponent } from './modules/auth/pages/registration-token-verification/registration-token-verification.component';
import { RefreshPageGuard } from './core/guard/refresh-page.guard';
import { PasswordExpiredComponent } from './modules/auth/pages/password-expired/password-expired.component';
import { ProviderGuard } from './core/guard/provider.guard';
import { ProviderRedirectComponent } from './core/components/provider-redirect.component';

const routes: Routes = [
  {
    path: 'donor/:cguid',
    component: ThemeBaseComponent,
    canActivate: [RefreshPageGuard],
    resolve: {
      donorCampaignListData: DonorCampaignsListResolver,
      CurrentCampaignsResolver
    },
    children: [{
        path: 'login',
        component: LoginPageComponent,
        outlet: 'sidebar'
      },
      {
        path: 'forgotpassword',
        component: ForgotPasswordComponent,
        outlet: 'sidebar'
      },
      {
        path: 'change-password',
        canActivate: [AuthGuard],
        component: ChangePasswordComponent,
        outlet: 'sidebar'
      },
      {
        path: 'landing',
        canActivate: [AuthGuard],
        component: LandingPageComponent,
        outlet: 'sidebar'
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@uw/modules/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
        outlet: 'profile-display'
      },
      {
        path: 'donation',
        loadChildren: () =>
          import('@uw/modules/donation/donation.module').then(
            (m) => m.DonationModule
          ),
      },
      // {
      //   path: 'my-campaign',
      //   loadChildren: () =>
      //     import('@uw/modules/my-campaign/my-campaign.module').then(
      //       (m) => m.MyCampaignModule
      //     ),
      // },
      {
        path: 'link1',
        loadChildren: () =>
          import('@uw/modules/link1/link1.module').then(
            (m) => m.Link1Module
          ),
      },
      {
        path: 'link2',
        loadChildren: () =>
          import('@uw/modules/link2/link2.module').then(
            (m) => m.Link2Module
          ),
      },
      {
        path: 'link3',
        loadChildren: () =>
          import('@uw/modules/link3/link3.module').then(
            (m) => m.Link3Module
          ),
      },
      {
        path: 'link4',
        loadChildren: () =>
          import('@uw/modules/link4/link4.module').then(
            (m) => m.Link4Module
          ),
      },
      {
        path: 'closed-campaign',
        loadChildren: () =>
          import('@uw/modules/closed-campaign/closed-campaign.module').then(
            (m) => m.ClosedCampaignModule
          ),
        canActivate: [CampaignGuard],  
      },
      { 
        path: '',
        component: WelcomePageComponent,
        resolve: {
          pageContent: WelcomePageContentResolver,
          CurrentCampaignsResolver
        },
        canActivate: [CampaignGuard],
      },

    ],
  },
  {
    path: 'donor-info',
    component: ThemeBaseComponent,
    resolve: {
      donorCampaignListData: DonorCampaignsListResolver
    },
    canActivate: [RefreshPageGuard, AuthGuard],
    children: [{
        path: 'login',
        component: LoginPageComponent,
        outlet: 'sidebar'
      },
      {
        path: 'forgotpassword',
        component: ForgotPasswordComponent,
        outlet: 'sidebar'
      },
      {
        path: 'change-password',
        canActivate: [AuthGuard],
        component: ChangePasswordComponent,
        outlet: 'sidebar'
      },
      {
        path: 'landing',
        canActivate: [AuthGuard],
        component: LandingPageComponent,
        outlet: 'sidebar'
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@uw/modules/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
        outlet: 'profile-display'
      },
      {
        path: '',
        loadChildren: () =>
          import('@uw/modules/donor-info/donor-info.module').then(
            (m) => m.DonorInfoModule
          ),
      },
    ],
  },
  {
    path: 'reset-password',
    component: StandaloneParentPageComponent,
    children: [{
      path: '',
      component: ResetPasswordComponent,
    }, ]
  },
  {
    path: 'forgot-password',
    component: StandaloneForgotPasswordComponent,
  },
  {
    path: 'mfa',
    component: MfaComponent,
  },
  {
    path: 'password-expired',
    component: PasswordExpiredComponent,
  },
  {
    path: 'app-selection',
    canActivate: [AuthGuard],
    component: AppSelectionComponent,
  },
  {
    path: 'user-registration-feedback',
    component: UserRegistrationFeedbackComponent,
  },
  {
    path: 'id-validate',
    component: RegistrationTokenVerificationComponent,
  },
  {
    path: 'main',
    loadChildren: () =>
      import('@uw/modules/standalone-login/standalone-login.module').then(
        (m) => m.StandaloneLoginModule
      ),
  },
  {
    path: 'provider/:providerId',
    canActivate: [ProviderGuard],
    component: ProviderRedirectComponent
  },
  {
    path: 'info',
    canActivate: [RefreshPageGuard],
    component: ThemeBaseComponent,
    resolve: {
      donorCampaignListData: DonorCampaignsListResolver,
    },
    children: [
      {
        path: 'faq',
        loadChildren: () =>
          import('@uw/modules/faq/faq.module').then((m) => m.FaqModule),
      },
      {
        path: 'help-desk',
        loadChildren: () =>
          import('@uw/modules/help-desk/help-desk.module').then(
            (m) => m.HelpDeskModule
          ),
      },
      {
        path: 'privacy-policy',
        loadChildren: () =>
          import('@uw/modules/privacy-policy/privacy-policy.module').then(
            (m) => m.PrivacyPolicyModule
          ),
      },
      {
        path: 'landing',
        canActivate: [AuthGuard],
        component: LandingPageComponent,
        outlet: 'sidebar',
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () =>
          import('@uw/modules/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
        outlet: 'profile-display',
      },
      {
        path: 'change-password',
        canActivate: [AuthGuard],
        component: ChangePasswordComponent,
        outlet: 'sidebar'
      },
    ],
  },
  {
    path: 'campaign-not-found',
    component: ErrorPageComponent,
  },
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],

})
export class EnAppRoutingModule {}
